<script lang="ts">
  import classnames from 'classnames';
  import { page } from '$app/stores';
  // Utils
  import { stringToSlug } from '@24hbs/utils';
  // Components
  // import { Modal } from '$lib/components/organisms/Modal';
  import { Button } from '$lib/components/atoms/Button';
  
  interface DetailCardData {
    thumbnailImage: string;
    title: string;
    abstract?: string;
    ctaText: string;
    content?: string;
    href?: string;
    target?: string;
  }

  export let data: DetailCardData;

</script>

{#if data.href}
  <section class={classnames('detail-card', $$props.class)}>
    <div class="detail-image-wrapper">
      <div class="detail-image">
        <img class="image" src={data.thumbnailImage} alt={data.title} />
      </div>
    </div>
    <div class="detail-content">
      <div class="detail-info">
        {#if data.target}
          <a href={data.href} target={data.target} class="detail-link">
            <h3 class="detail-title">{data.title}</h3>
          </a>
        {:else}
          <a href={data.href} class="detail-link">
            <h3 class="detail-title">{data.title}</h3>
          </a>
        {/if}
        <p class="detail-abstract">
          {#if $$slots.default}
            <slot />
          {:else}
            {data.abstract}
          {/if}
        </p>
      </div>
      {#if data.target}
        <Button href={data.href} target={data.target} class="mt-4 mx-auto detail-link" minWidthSmall noMinWidth>{data.ctaText}</Button>
      {:else}
        <Button href={data.href} class="mt-4 mx-auto detail-link" minWidthSmall noMinWidth>{data.ctaText}</Button>
      {/if}
    </div>
  </section>
{:else}
  <section class={classnames('detail-card', $$props.class)}>
    <div class="detail-image-wrapper">
      <div class="detail-image">
        <img class="image" src={data.thumbnailImage} alt={data.title} />
      </div>
    </div>
    <div class="detail-content">
      <div class="detail-info">
        <h3 class="detail-title">{data.title}</h3>
        <p class="detail-abstract">
          {data.abstract}
        </p>
      </div>
      <Button

        href={`${$page.url.pathname}/${stringToSlug(data.title)}/contact`}
        class="mt-4 mx-auto"
        minWidthSmall
        noMinWidth
      >
        {data.ctaText}
      </Button>
    </div>
  </section>
{/if}

<!-- <Modal bind:open on:close={() => (open = false)} showCloseButton compact closeOnBackdropClick>
  <slot name="modalBody">
    {@html data.content}
  </slot>
</Modal> -->

<style type="text/scss" lang="scss" scoped>
  .detail-card {
    @apply grid;
    @apply relative;
    @apply w-full h-full;
    @apply rounded;
    @apply shadow-card-inset;
    @apply bg-white;

    grid-template-rows: auto 1fr;

    /* Using pseudo elements for hover effects on box-shadow
    is much better for performance
    See: https://tobiasahlin.com/blog/how-to-animate-box-shadow/ */

    &:before,
    &:after {
      @apply duration-500 transition-opacity ease-in-out;
    }

    /* Default State */
    &:before {
      content: '';
      @apply rounded;
      @apply absolute inset-0;
      @apply shadow-card opacity-100;
    }

    &:hover:before {
      @apply opacity-0;
    }

    /* Hover State */
    &:after {
      content: '';
      @apply rounded;
      @apply absolute inset-0;
      @apply shadow-card-hover opacity-0;
    }
    &:hover:after {
      @apply opacity-100;
    }

    &:hover {
      & .image {
        @apply transform scale-105;
      }
    }
  }

  .detail-image {
    @apply overflow-hidden;
    @apply rounded-t;
    @apply aspect-w-5 aspect-h-3;
  }

  .image {
    @apply object-cover;
    @apply transition-transform duration-500 ease-in-out;
    will-change: transform;
  }

  .detail-content {
    @apply z-20;
    @apply overflow-hidden;
    @apply p-6;
    @apply h-full;
    @apply flex flex-col;
  }
  .detail-info {
    @apply flex-grow;
  }

  .detail-date {
    @apply uppercase tracking-wide font-semibold;
    @apply text-gray-600 text-sm md:text-base;
  }

  .detail-date + .detail-link {
    @apply mt-4 md:mt-5;
  }

  .detail-title {
    @apply text-md md:text-xl lg:text-3xl leading-tight md:leading-tight lg:leading-tight;
  }

  .detail-link {
    @apply inline-block;
    @apply text-gray-900 font-medium font-serif;

    &:after {
      content: '';
      @apply absolute inset-0;
      @apply z-10;
    }
  }

  .detail-link,
  .detail-abstract {
    overflow: hidden;
    display: -webkit-box;
  }

  .detail-link + .detail-abstract {
    @apply mt-3;
  }

  .detail-abstract {
    @apply text-sm md:text-base;
  }
</style>
